<template>
  <div class="final-quiz-item-component">
    <div class="d-flex align-items-center w-100">
      <div class="d-flex align-items-center text-truncate flex-fill">
        <h5 class="text-semibold">{{ quiz.title }}</h5>
        <span v-if="quiz.status === 'draft'" class="ml-5 draft-badge">
          Rascunho
        </span>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <div class="d-flex gap-2">
          <snow-button text="Editar" size="sm" variant="gray" @click="onEdit" />
          <snow-button
            text="Excluir"
            size="sm"
            variant="danger"
            @click="removeConfirmation = true"
          />
        </div>
      </div>
    </div>
    <snow-dialog
      v-model="removeConfirmation"
      icon="ph ph-trash"
      secondaryButtonText="Cancelar"
      ButtonText="Excluir"
      text="Tem certeza que deseja excluir a avaliação final?"
      @action="onRemove"
    />
  </div>
</template>
<script>
export default {
  props: {
    quiz: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      removeConfirmation: false
    };
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: "product-members-module-quizz-final-edit",
        params: { id: this.$route.params.id }
      });
    },
    onRemove() {
      this.$store
        .dispatch("membersQuizzes/deleteFinal", this.quiz.product_id)
        .then(() => {
          this.$emit("refresh");
          this.$message.success("A prova final foi excluída!");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.final-quiz-item-component {
  background: var(--bg-1);
  border-radius: 16px;
  border: 1px solid var(--dark-10);
  padding: 24px;
  width: 100%;

  .title {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
